// import * as Sentry from '@sentry/nextjs'
// import { isAxiosError } from 'axios'

import axiosInstance from '@/_lib/axiosInstance'
import { ApiResponse, IAnnualProgramDiscountType, IAnnualProgramReduced } from '@/_types'

import type { IAnnualProgramDiscountData } from '@/app/[locale]/order/_types/annual-program-discount'

interface ClientVerifyAnnualProgramApiResponseData {
	discountType: IAnnualProgramDiscountType
	yearProgram: IAnnualProgramReduced
	canDiscountTemplate: boolean
}

/**
 * POSTs patient identifiers to verify annual-program discount eligibility before checkout.
 *
 * @param payload - Patient identity and optional `templateId` for template-specific rules.
 * @returns Normalized {@link IAnnualProgramDiscountData} when the API returns a body, otherwise `null`.
 * @throws Propagates axios/network errors from the underlying POST (Sentry hooks are currently commented out).
 */
export const clientVerifyAnnualProgram = async (payload: {
	firstName: string
	lastName: string
	birthNumber: string
	templateId?: number
}): Promise<IAnnualProgramDiscountData | null> => {
	try {
		const response = await axiosInstance.post<
			ApiResponse<ClientVerifyAnnualProgramApiResponseData>
		>('v1/web/yearProgram/clientVerify', payload)

		if (response?.data?.data) {
			const body = response.data.data

			return {
				discountType: body.discountType,
				annualProgram: body.yearProgram,
				canDiscountTemplate: body.canDiscountTemplate
			}
		}

		return null
	} catch (error: unknown) {
		// const status = isAxiosError(error) ? error.response?.status : undefined
		// if (status !== 404) {
		// 	Sentry.captureException(error, {
		// 		tags: { endpoint: 'yearProgram/clientVerify' },
		// 		extra: {
		// 			requestPayload: {
		// 				firstName: payload.firstName,
		// 				lastName: payload.lastName,
		// 				birthNumber: payload.birthNumber,
		// 				templateId: payload.templateId
		// 			}
		// 		}
		// 	})
		// }
		throw error
	}
}
